<!--
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2023-05-18 10:43:52
 * @LastEditors: dyl
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/frameworks/layouts/components/Sidebar/index.vue
-->
<template>
  <div>
    <div
      class="sidebar-collapse-btn"
      :class="isCollapse ? '' : 'collapse-unfold'"
      @click="toggleSideBar"
    >
      <!-- <i class="bowtie-icon bowtie-menu" /> -->
      <!-- <svg-icon
        :icon-class="isCollapse ? 'fold' : 'unfold'"
        class-name="item-btn-icon"
        style="margin: 0 8px"
      /> -->
      <i class="w-icon-list"></i>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- :default-active="$route.path" -->
      <el-menu
        :show-timeout="200"
        unique-opened
        :collapse="isCollapse"
        mode="vertical"
        text-color="#303133"
        active-text-color="#409EFF"
        :default-active="defaultActive"
        @select="select"
      >
        <sidebar-item-to-menu
          v-for="menuItem in menuItemDatas"
          :key="menuItem.id"
          :item="menuItem"
          :base-path="menuItem.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItemToMenu from './SidebarItemToMenu'

export default {
  components: { SidebarItemToMenu },
  data() {
    return {
      defaultActive: this.$route?.path || ''
    }
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'selectedFirstLLevelMenuitem',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    menuItemDatas() {
      if (
        this.selectedFirstLLevelMenuitem &&
        this.selectedFirstLLevelMenuitem.children
      ) {
        return this.selectedFirstLLevelMenuitem.children
      } else {
        return []
      }
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    select(index, indexPath) {
      this.defaultActive = index
    }
  }
}
</script>
